module.exports = __webpack_public_path__ + "/login_ui/img/io-0cd14b1ff1e4831b394744be508c607f.svg";